import { Category } from 'app/shared/model/enumerations/category.model';

export interface ICategoryMaster {
  id?: number;
  category?: keyof typeof Category | null;
}

export const defaultValue: Readonly<ICategoryMaster> = {};
